// session.api.js
import { api } from "../utils/axios";

// ========================
// SESSION APIs
// ========================

/**
 * Fetch all sessions for a specific dome (with optional search & pagination)
 * @param {string} domeId - the dome's ObjectId
 * @param {string} [search] - optional search query
 * @param {number} [page=1] - page number
 * @param {number} [limit=9] - results per page
 */
export const fetchSessionsByDome = async (domeId, search = "", page = 1, limit = 9) => {
  if (!domeId) throw new Error("domeId is required");

  try {
    const response = await api.get(`/dome/session/dome/${domeId}`, {
      params: { search, page, limit },
    });

    return response.data.data; // keep consistency with backend ApiResponse
  } catch (error) {
    console.error("Error fetching sessions by dome:", error);
    throw error;
  }
};


/**
 * Fetch a single session by ID
 * @param {string} id - session ObjectId
 */
export const fetchSessionById = async (id) => {
  if (!id) throw new Error("session id is required");

  try {
    const response = await api.get(`/dome/session/${id}`);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching session by ID:", error);
    throw error;
  }
};

/**
 * Create a new session
 * @param {Object} sessionData - { domeRef, name, startTime, duration }
 */
export const createSession = async (sessionData) => {
  try {
    const response = await api.post(`/dome/session/`, sessionData);
    return response.data.data;
  } catch (error) {
    console.error("Error creating session:", error);
    throw error;
  }
};

/**
 * Update a session
 * @param {string} id - session ObjectId
 * @param {Object} updateData - { name?, startTime?, duration? }
 */
export const updateSession = async (id, updateData) => {
  if (!id) throw new Error("session id is required");

  try {
    const response = await api.patch(`/dome/session/${id}`, updateData);
    return response.data.data;
  } catch (error) {
    console.error("Error updating session:", error);
    throw error;
  }
};

/**
 * Delete a session
 * @param {string} id - session ObjectId
 */
export const deleteSession = async (id) => {
  if (!id) throw new Error("session id is required");

  try {
    const response = await api.delete(`/dome/session/${id}`);
    return response.data.data;
  } catch (error) {
    console.error("Error deleting session:", error);
    throw error;
  }
};
